<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    :fill="fill"
  >
    <path d="M6.93994 5.00002C6.93968 5.53046 6.72871 6.03906 6.35345 6.41394C5.97819 6.78883 5.46937 6.99929 4.93894 6.99902C4.40851 6.99876 3.89991 6.78779 3.52502 6.41253C3.15014 6.03727 2.93968 5.52846 2.93994 4.99802C2.94021 4.46759 3.15117 3.95899 3.52644 3.5841C3.9017 3.20922 4.41051 2.99876 4.94094 2.99902C5.47137 2.99929 5.97998 3.21026 6.35486 3.58552C6.72975 3.96078 6.94021 4.46959 6.93994 5.00002ZM6.99994 8.48002H2.99994L2.99994 21H6.99994L6.99994 8.48002ZM13.3199 8.48002H9.33994L9.33994 21H13.2799V14.43C13.2799 10.77 18.0499 10.43 18.0499 14.43V21H21.9999L21.9999 13.07C21.9999 6.90002 14.9399 7.13002 13.2799 10.16L13.3199 8.48002Z"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsLinkedin'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
